export default "/react/logoEnvybox-412399b0.png";